import { createContext } from 'react';
import initialBrandsState from './initialBrandsState';

const BrandsContext = createContext(initialBrandsState);

export default BrandsContext;
